import type { RelayRequest, RelayResponse } from '../types';
import type { RequestFn } from '../client';

export class Relay {
  constructor(private readonly request: RequestFn) {}

  async create(params: RelayRequest): Promise<RelayResponse> {
    return this.request('POST', '/relay', { body: params });
  }

  async retrieve(relayId: string): Promise<RelayResponse> {
    return this.request('GET', `/relay/${encodeURIComponent(relayId)}`);
  }
}
